module.exports = __webpack_public_path__ + "img/escalator2.063db4ce.png";